<cer-form #form [panes]="panesMain">
  <ng-template #mainTemplate>
    <cer-grid #grid [formView]="formView" [id]="formView?.id"
      [viewMetadata]="viewMetadata" [fieldMetadata]="fieldMetadata"
      [fieldGroupMetadata]="fieldGroupMetadata" [editSettings]="editSettings"
      [contextMenuCommands]="contextMenuCommands" (commmand)="onCommand($event)"></cer-grid>
  </ng-template>
</cer-form>